import {
  centerDivContainer,
  leftTextContent,
  rightContentInputBox,
} from '../../styles';

function OverviewInputContainer(props) {
  return (
    <div style={centerDivContainer}>
      <div style={leftTextContent}>*{props.label}:</div>
      <div style={rightContentInputBox}>{props.children}</div>
    </div>
  );
}

export default OverviewInputContainer;
